import * as React from 'react';
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 30 30"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.7 0h12.6C26.1 0 30 3.9 30 8.7v12.6a8.696 8.696 0 0 1-8.7 8.7H8.7C3.9 30 0 26.1 0 21.3V8.7c0-2.307.917-4.52 2.549-6.151A8.7 8.7 0 0 1 8.7 0m-.3 3A5.4 5.4 0 0 0 3 8.4v13.2C3 24.585 5.415 27 8.4 27h13.2a5.4 5.4 0 0 0 3.819-1.581A5.4 5.4 0 0 0 27 21.6V8.4C27 5.415 24.585 3 21.6 3zm14.475 2.25a1.87 1.87 0 0 1 1.875 1.875A1.87 1.87 0 0 1 22.875 9a1.872 1.872 0 0 1-1.325-3.2c.351-.352.828-.55 1.325-.55M15 7.5a7.502 7.502 0 0 1 0 15A7.5 7.5 0 0 1 7.5 15 7.503 7.503 0 0 1 15 7.5m0 3a4.5 4.5 0 1 0 0 9.001 4.5 4.5 0 0 0 0-9.001"
    />
  </svg>
);
export default SvgComponent;
